/*
 * @Author: LZT
 * @Date: 2024-12-11 16:15:19
 * @LastEditors: ITDLCL
 * @Description:
 * @FilePath: \qs\src\router\modules\user.js
 */
import Layout from "@/Layout";
export default [
  {
    path: "/",
    redirect: "/home/index",
    component: Layout,
    children: [
      {
        path: "home/index",
        component: () => import("@/views/gnPage/home/index.vue"),
        name: "home",
        meta: {
          icon: "guide",
          title: "首页",
          keepAlive: true,
          showFooter: true,
          current_page_id: "30-21"
        }
      }
    ]
  },
  {
    path: "/information",
    component: Layout,
    name: "Information",
    redirect: "/information/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/information/index.vue"),
        meta: {
          title: "古灵通资讯",
          keepAlive: false,
          showHead: false,
          showLeft: false
        }
      }
    ]
  },
  {
    path: "/teaching",
    component: Layout,
    name: "Teaching",
    redirect: "/teaching/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/teaching/index.vue"),
        meta: {
          title: "", // 新手教学页
          keepAlive: false,
          showFooter: false,
          showHead: false,
          showLeft: false,
          showRight: false
        }
      },
      {
        path: "indexFlutter",
        component: () => import("@/views/teaching/indexFlutter.vue"),
        meta: {
          title: "", // 新手教学页 Flutter版
          keepAlive: false,
          showFooter: false,
          showHead: false,
          showLeft: false,
          showRight: false
        }
      },
    ]
  },
  {
    path: "/strategy",
    component: Layout,
    name: "Strategy",
    redirect: "/strategy/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/strategy/index.vue"),
        meta: {
          title: "", // 策略页
          keepAlive: false,
          showFooter: false,
          showHead: false,
          showLeft: false,
          showRight: false
        }
      },
      {
        path: "history",
        component: () => import("@/views/strategy/strategyHistory.vue"),
        meta: {
          title: "", // 策略池 往期数据页
          keepAlive: false,
          showFooter: false,
          showHead: false,
          showLeft: false,
          showRight: false
        }
      },
    ]
  },
];
